import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 6,
    label: 'NAME_KEY',
    stateKey: 'first_name',
  },
  {
    gridXs: 6,
    label: 'LAST_NAME_KEY',
    stateKey: 'last_name',
  },
  {
    gridXs: 12,
    label: 'EMAIL_KEY',
    stateKey: 'email',
  },
  {
    gridXs: 12,
    label: 'USER_AD_KEY',
    stateKey: 'username',
  },
  {
    gridXs: 6,
    label: 'PROFILE_PATH_KEY',
    stateKey: 'profile_path',
    disabled: true,
  },
  {
    gridXs: 12,
    label: 'EMAIL_FICTITIOUS_KEY',
    stateKey: 'fictitious_email',
    fontSize: '14px',
    isRadioGroup: true,
    radioGroupOptions: [
      { value: true, label: 'YES_KEY' },
      { value: false, label: 'NO_KEY' },
    ],
  },
  {
    gridXs: 12,
    label: 'IS_INTEGRATION_USER_KEY',
    stateKey: 'is_integration_user',
    fontSize: '14px',
    isRadioGroup: true,
    radioGroupOptions: [
      { value: true, label: 'YES_KEY' },
      { value: false, label: 'NO_KEY' },
    ],
  },
  {
    gridXs: 4,
    label: 'Salt',
    stateKey: 'ad_password_salt.salt',
    isPassword: true,
    disabled: true,
  },
  {
    gridXs: 12,
    label: 'SALT.REASON_SALT_KEY',
    stateKey: 'ad_password_salt.skip_reason',
  },
  {
    gridXs: 12,
    label: 'SALT.REASON_TO_SKIP_KEY',
    stateKey: 'ad_password_salt.skip_reason',
    disabled: true,
  },
];

export default fields;
